import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApiV2 } from "../DbCenterBaseApiV2";

export class ResourceServerApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'resourceServer';
    }

    public getResourceServer() {
        return this.send({}, "getResourceServer", Methods.GET);
    }

    public getDbByServerId(serverId:number,dbType:string ) {
        return this.send({serverId,dbType}, "getDbByServerId", Methods.GET);
    }


    
}